export default "/images/54e3e4366da509a17afb88f738891fe2.avif";